import { Text } from "@chakra-ui/react";
import * as React from 'react';
export default {
  Text,
  React
};